var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-spin", { attrs: { size: "large", spinning: _vm.loading } }, [
    _c("div", { staticClass: "home" }, [
      _c("div", { staticClass: "top-box" }, [
        _c("p", [
          _c("span", { class: [_vm.lang] }, [
            _vm._v(" 📊 " + _vm._s(_vm.$t("Personalized"))),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "btn", class: [_vm.lang], on: { click: _vm.goBack } },
          [
            _c("a-icon", {
              staticClass: "icon",
              attrs: { type: "arrow-left" },
            }),
            _vm._v(" " + _vm._s(_vm.$t("ReturnConsultation")) + " "),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "main-box" }, [
        _c("iframe", {
          staticClass: "frame",
          style: { height: _vm.maxWindowHeight + "px" },
          attrs: { id: "myframe" },
        }),
        _c(
          "div",
          { staticClass: "bottom" },
          [
            _c(
              "a-button",
              {
                class: [_vm.lang],
                attrs: {
                  type: "primary",
                  size: "large",
                  id: "recruiter-create-btn",
                },
                on: { click: _vm.createCampaign },
              },
              [_vm._v(" " + _vm._s(_vm.$t("CreateCampaign")) + " ")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }